import { simpleReplaceCrypto } from '@/utils/tool'
export default {
    state: {
        authAcc: ['cyy_202507'],
        authMenu: ['/belt','/beltinfo'],
        username: sessionStorage.getItem('cyy_menu') || ''
    },
    mutations: {
        // 修改菜单展开收起的方法
        username (state, payload) {
            state.username = (payload || '').trim()
            sessionStorage.setItem('cyy_menu', state.username)
        }
    }
}